<template>
  <div class="counter-container bg-white rounded-lg shadow-sm" ref="container">
    <div
      class="stat-card transform transition-all duration-300 hover:scale-105"
      v-for="(stat, index) in stats"
      :key="index"
    >
      <h3 class="text-4xl font-bold text-indigo-600 mb-2" ref="numbers">
        {{ stat.value }}{{ stat.suffix }}
      </h3>
      <p class="text-gray-600 text-lg">{{ stat.label }}</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "AnimatedCounter",
  props: {
    stats: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every(
          (stat) =>
            typeof stat.value === "number" &&
            typeof stat.label === "string" &&
            (!stat.suffix || typeof stat.suffix === "string")
        );
      },
    },
  },
  setup(props) {
    const container = ref(null);
    const numbers = ref([]);

    onMounted(() => {
      ScrollTrigger.batch(numbers.value, {
        onEnter: (elements) => {
          elements.forEach((element, index) => {
            const stat = props.stats[index];
            gsap.fromTo(
              element,
              {
                textContent: "0",
                opacity: 0,
                y: 20,
              },
              {
                textContent: stat.value,
                opacity: 1,
                y: 0,
                duration: 1.5,
                ease: "power2.out",
                snap: { textContent: 1 },
                stagger: 0.2,
                onComplete: () => ScrollTrigger.refresh(),
              }
            );
          });
        },
        once: true,
      });
    });

    return {
      container,
      numbers,
    };
  },
};
</script>

<style scoped>
.counter-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  padding: 2rem;
  margin: 2rem 0;
}

.stat-card {
  text-align: center;
  padding: 1.5rem;
  background: linear-gradient(
    to bottom right,
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 0.4)
  );
  border-radius: 0.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(209, 213, 219, 0.3);
}

@media (max-width: 640px) {
  .counter-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 1.5rem;
  }
}
</style>
